// extracted by mini-css-extract-plugin
export default {"wrapper":"nucpGURy0AJ5iem5SnFF"};